import React from 'react';
import AppBar from '@mui/material/AppBar';
import { Divider, Link, Stack, Toolbar, Typography } from '@mui/material';

import aboutPDF from './../footer/about-regulatory-world-map.pdf';
import tosPDF from './../footer/tos-regulatory-world-map.pdf';
import { configService } from '../../service';

const Footer = () => {
    return (
        <AppBar color="primary" position="static">
            <Toolbar>
                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} fullWidth style={{ width: '100%' }}>
                    <Stack direction={'row'} alignContent={'center'} justifyContent={'center'}>
                        <Link href={aboutPDF} without="true" rel="noopener noreferrer" target="_blank" color="#FFFFFF">
                            About
                        </Link>
                        <Divider sx={{ border: '1px solid #da1f33', margin: '0 12px' }} orientation="vertical" flexItem />
                        <Link href={tosPDF} without="true" rel="noopener noreferrer" target="_blank" color="#FFFFFF">
                            Terms of Use
                        </Link>
                        <Divider sx={{ border: '1px solid #da1f33', margin: '0 12px' }} orientation="vertical" flexItem />
                        <Link href="https://abs.jotform.com/222194343602954" without="true" rel="noopener noreferrer" target="_blank" color="#FFFFFF">
                            Give Feedback
                        </Link>

                        <Divider sx={{ border: '1px solid #da1f33', margin: '0 12px' }} orientation="vertical" flexItem />
                        <Typography>Copyright © 2016-2023 by ABS. All rights reserved.</Typography>
                    </Stack>

                    <Typography>v{configService.appConfig.lastUpdate}</Typography>
                </Stack>
            </Toolbar>
        </AppBar>
    );
};

export default Footer;
